import React, {useState, useEffect} from "react";
import styled from "styled-components";
import MainVideo from "./MainVideo";
import { pulse } from "../../animations/pulse";
import {useSearchParams} from "react-router-dom";

const LeftContainer = styled.div`
  width: 100%;
  margin-right: 20px;
  gap: 16px;
  display: flex;
  flex-direction: column;
  @media (max-width: 1140px) {
    width: 100%;
    align-items: center;
  }
`;

const Title = styled.span`
  font-family: Merriweather;
  font-size: 31.25px;
  font-weight: 700;
  line-height: 39.28px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: rgba(18, 30, 60, 1);
  align-self: flex-start;
  @media (max-width: 500px) {
    font-size: 20px;
    line-height: 28px;
  }
`;

const EmptyTitle = styled.div`
  width: 100%;
  height: 78.56px;
  background: rgba(217, 217, 217, 1);
  animation: ${pulse} 1s infinite alternate;
  @media (max-width: 500px) {
    height: 56px;
  }
  @media (max-width: 1139px) and (min-width: 501px) {
    height: 39.28px;
  }
`;

const EmptyDescription = styled.div`
  width: 100%;
  height: 43.58px;
  background: rgba(217, 217, 217, 1);
  animation: ${pulse} 1s infinite alternate;
  align-self: flex-start;
  @media (max-width: 1140px) {
    margin-bottom: 20px;
    margin-top: -20px;
  }
`;

const Description = styled.span`
  font-family: Open Sans;
  font-size: 16px;
  font-weight: 400;
  line-height: 21.79px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: rgba(18, 30, 60, 1);
  align-self: flex-start;
  @media (max-width: 1140px) {
    margin-bottom: 20px;
  }
`;

const MainVideoColumn = (props) => {
  const [selectedMediaSource, setSelectedMediaSource] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    let media = searchParams.get("platform");
    let selectedMedia = findMediaSource(media?.toUpperCase());
    setSelectedMediaSource(selectedMedia);
  }, [props.video]);

  const findMediaSource = (source) => {
    if (props.video == null ) {
      return null
    }
    for (const mediaSource of props.video?.mediaSources) {
      if (mediaSource.platform === source) {
        return mediaSource
      }
    }
    return props.video?.mediaSources[0]
  }

  const changeSource = (source) => {
    let selectedMedia = findMediaSource(source);
    setSelectedMediaSource(selectedMedia);
    searchParams.set("platform", selectedMedia.platform.toLowerCase());
    setSearchParams(searchParams);
  }

  return (
    <LeftContainer>
      <MainVideo
        src={
            selectedMediaSource ? selectedMediaSource.url : null
        }
        loading={props.loading}
      />
    <div style={{display: "inline-block"}}>
        <img src="images/youtube.png"
             alt="youtube"
             style={{ width: '24px', "marginRight": '5px', cursor: "pointer" }}
             onClick={() => changeSource("YOUTUBE")}
        />
        <img src="images/odysee.png"
             alt="odysee"
             style={{ width: '24px', "marginRight": '5px', cursor: "pointer"}}
             onClick={() => changeSource("ODYSEE")}
        />
        <img src="images/bitchute.png"
             alt="bitchute"
             style={{ width: '24px', "marginRight": '5px', cursor: "pointer"}}
             onClick={() => changeSource("BITCHUTE")}
        />
        <img src="images/rumble.png"
             alt="rumble"
             style={{ width: '24px', "marginRight": '5px', cursor: "pointer"}}
             onClick={() => changeSource("RUMBLE")}
        />
    </div>
      <Title>
        {props.video?.title && !props.loading ? props.video.title : ""}
      </Title>
      {(!props.video?.title || props.loading) && <EmptyTitle></EmptyTitle>}
      <Description>
        {props.video?.description && !props.loading
          ? props.video.description
          : ""}
      </Description>
      {(!props.video?.description || props.loading) && <EmptyDescription />}
    </LeftContainer>
  );
};

export default MainVideoColumn;
